import weui from "weui.js";
import Alert from "./components/Alert/Alert";

export const TEAM_COLORS = {
  1: "#ff0000",
  2: "#ffb400",
  3: "#00c6ff",
  4: "#c3ff00",
  5: "#ff6600",
  6: "#ac40ff",
  7: "#00ffba",
  8: "#1c47ff",
  9: "#ff2dd5",
  10: "#48ff00",
};

const SESSION_UUID_KEY = "session_uuid";
const TEAM_UUID_KEY = "team_uuid";
const PLAYER_CODE_KEY = "player_code";

export const saveSessionUUID = (session_uuid) => {
  window.localStorage.setItem(SESSION_UUID_KEY, session_uuid);
};
export const getSessionUUID = () => {
  return window.localStorage.getItem(SESSION_UUID_KEY);
};

export const saveTeamUUID = (team_uuid) => {
  window.localStorage.setItem(TEAM_UUID_KEY, team_uuid);
};
export const getTeamUUID = () => {
  return window.localStorage.getItem(TEAM_UUID_KEY);
};

export const savePlayerCode = (player_code) => {
  window.localStorage.setItem(PLAYER_CODE_KEY, player_code);
};
export const getPlayerCode = () => {
  return window.localStorage.getItem(PLAYER_CODE_KEY);
};

export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export function showLoading(txt) {
  const loading = weui.loading(txt);
  return loading;
}

export function showAlert(txt, title) {
  // weui.alert(txt);
  Alert.show({
    type: "alert",
    title: title || "提交失败",
    message: txt,
    onClose: () => {},
  });
}

export function showToast(txt) {
  weui.toast(txt);
}

// REM 适配
const REM_FIT_WIDTH = 1125;
function setPxPerRem() {
  const docEl = document.documentElement;
  docEl.style.fontSize = docEl.clientWidth / REM_FIT_WIDTH + "px";
}
export function enableRemAdaptor() {
  setPxPerRem();
  window.onresize = setPxPerRem;
}
export const px2rem = (value) => {
  const docEl = document.documentElement;
  return value / (docEl.clientWidth / REM_FIT_WIDTH);
};
export const rem2px = (value) => {
  const docEl = document.documentElement;
  return value * (docEl.clientWidth / REM_FIT_WIDTH);
};

// 发送 HTTP 请求
export async function apiRequest(path, method, params) {
  let url = `${API_SERVER_URL}${path}`;
  const fetchParams = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (method === "POST") fetchParams.body = JSON.stringify(params);
  if (method === "GET" && params) {
    const parmasArray = [];
    Object.keys(params).forEach((key) => {
      parmasArray.push(`${key}=${params[key]}`);
    });
    url = url + "?" + parmasArray.join("&");
  }
  const resp = await fetch(url, fetchParams);
  return resp.json();
}

// 图片压缩函数
export const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        // 计算压缩后的尺寸
        const maxSize = 1024; // 最大尺寸
        if (width > height && width > maxSize) {
          height = Math.round((height * maxSize) / width);
          width = maxSize;
        } else if (height > maxSize) {
          width = Math.round((width * maxSize) / height);
          height = maxSize;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // 压缩质量
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(
                new File([blob], file.name, {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                })
              );
            } else {
              reject(new Error("图片压缩失败"));
            }
          },
          "image/jpeg",
          0.7 // 压缩质量，0.7表示70%的质量
        );
      };
      img.onerror = (error) => reject(error);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const formatPlayerNo = (player_no) => {
  if (player_no < 10) {
    return `0${player_no}`;
  } else {
    return `${player_no}`;
  }
};

export const getEnergyHubPeopleNumText = (photo_num) => {
  return photo_num === -1 ? "全队成员" : `${photo_num}人`;
};

export const replaceUrlParams = (key, value) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, "", url);
};
